// extracted by mini-css-extract-plugin
module.exports = {"button":"InfosystemConfig_button__76vRF"};